// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"6a03b3ed","145":"8a8c0fe6","553":"8a8c0fe6"}[chunkId] + ".chunk.css";
};